import { Reducer } from 'redux';
import { SignUpFieldsState, SignUpFieldsTypes } from './types';

const INITIAL_STATE: SignUpFieldsState = {
  data: [],
  loading: false,
  sendLoading: false,
};

const reducer: Reducer<SignUpFieldsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SignUpFieldsTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case SignUpFieldsTypes.LOAD_SUCCESS:
      return {
        ...state,
        loaded: true,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case SignUpFieldsTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        ...action.payload,
      };

    case SignUpFieldsTypes.SEND_REQUEST:
      return {
        ...state,
        sendLoading: true,
      };
    case SignUpFieldsTypes.SEND_SUCCESS:
      return {
        ...state,
        sendLoading: false,
        error: undefined,
        ...action.payload,
      };
    case SignUpFieldsTypes.SEND_FAILURE:
      return {
        ...state,
        sendLoading: false,
        ...action.payload,
      };
    case SignUpFieldsTypes.CLEAN_STATE:
      return {
        ...state,
        success: undefined,
        sendError: undefined,
      };

    default:
      return state;
  }
};

export default reducer;
